import { ReactNode } from 'react'

import { Grid } from '@chakra-ui/react'

interface FourColumnGridIProps {
  children: ReactNode
  key?: string
}

export const FourColumnGrid = ({ children, key }: FourColumnGridIProps) => {
  return (
    <Grid
      gap='6'
      key={key || undefined}
      mb='4'
      templateColumns={{
        base: 'repeat(1, 1fr)',
        md: 'repeat(2, 1fr)',
        lg: 'repeat(4, 1fr)',
      }}
    >
      {children}
    </Grid>
  )
}
